import VueCookies from 'vue-cookies';

// Host del sitio desde el que llego la persona, o "directo" si no hubo referrer. Explica las
// sesiones que llegan sin utm_source ni utm_tracking: viaja en cada paso del embudo y el admin
// de Tracking lo muestra en la columna "Origen sin UTM".
export const REFERRER_COOKIE = "urg_referrer";

const REFERRER_DIRECTO = "directo";

// Misma vida que las cookies de los UTM (common.js), asi el origen sin UTM cubre la misma
// ventana que los UTM.
const REFERRER_COOKIE_DAYS = "2d";

let Capturado = false;

const getReferrerHost = () =>
{
    try
    {
        return document.referrer ? new URL(document.referrer).hostname : "";
    }
    catch(error)
    {
        return "";
    }
}

// Se llama desde el router en cada navegacion, pero el referrer es el de la carga de la
// pagina: en una SPA no cambia al navegar, asi que alcanza con mirarlo una vez.
export const captureReferrer = () =>
{
    if (Capturado || typeof window === "undefined") return;
    Capturado = true;

    const Host = getReferrerHost();

    // Recarga o vuelta desde otra pantalla del mismo sitio: no dice nada del origen.
    if (Host === window.location.hostname) return;

    if (Host)
    {
        VueCookies.set(REFERRER_COOKIE, Host, REFERRER_COOKIE_DAYS);
        return;
    }

    // Sin referrer: URL tipeada, favoritos o un link abierto desde una app (WhatsApp, mail).
    // No pisa un origen anterior: si ayer vino de Google y hoy vuelve tipeando, sigue siendo Google.
    if (!VueCookies.get(REFERRER_COOKIE)) VueCookies.set(REFERRER_COOKIE, REFERRER_DIRECTO, REFERRER_COOKIE_DAYS);
}
